import {collection, getDocs, getFirestore, orderBy, query, where} from "firebase/firestore";
import {useEffect, useState} from "react";

export  function CelebOrderHistory(props){
    const db=getFirestore();
    const [requests,setRequests]= useState([]);

    useEffect(async()=>{

        const q = query(collection(db, "requests"), where("celebrity", "==",props.id),orderBy("createdAt"));
        var docs=await getDocs(q);

        var requests=[];

        docs.forEach(element => {
            requests.push(element.data());
        });

        setRequests([...requests]);

    },[]);



    return(
        <div className="h-96 w-full bg-white/50 overflow-scroll flex-col p-3 rounded">
            <div className="h-24 w-full bg-black mb-2 text-white flex justify-start items-center flex-row p-3  overflow-x-scoll">


                <div className="pl-5 w-1/4">
                    Type
                </div>

                <div className="pl-5 w-32 overflow-scroll">
                    Amount
                </div>
                <div className="pl-5 w-32 overflow-scroll">
                    Discount
                </div>
                <div className="pl-5 w-32">
                    Date
                </div>
                <div className="pl-5 w-32">
                    Status
                </div>

            </div>
            {
                requests.map((request,index)=>{
                    return(

                        <div className="h-24 w-full bg-black mb-2 text-white flex justify-start items-center flex-row p-3  overflow-x-scoll">



                            <div className="pl-5 w-1/4">
                                {request["type"]==="dm"?"Direct Message":""}
                                {request["type"]==="videoRequest"?"Video Request":""}
                                {request["type"]==="eventBooking"?"Event Booking":""}
                            </div>

                            <div className="pl-5 w-32 overflow-scroll">
                                {request["amount"]} GHS
                            </div>
                            <div className="pl-5 w-32 overflow-scroll">
                                {request["discount"]} GHS
                            </div>
                            <div className="pl-5 w-32">
                                {request["createdAt"].toDate().getDate().toString()}-{(request["createdAt"].toDate().getMonth()+1).toString()}-{request["createdAt"].toDate().getFullYear().toString()}
                            </div>
                            <div className="pl-5 w-32">
                                {request["status"]}
                            </div>

                        </div>

                    )
                })
            }

        </div>
    )
}